import "./assets/animation/styles.css";

import React from "react";
import {
  TransitionGroup,
  CSSTransition
} from "react-transition-group";
import {
  Switch,
  Route,
  Link,
  useLocation,
} from "react-router-dom";
import Services from './containers/components/Services'
import ContactUs from './containers/ContactUs'
import MainPage from "./containers/components/MainPage";
import SignUp from "./auth/components/SignUp";
import SignIn from "./auth/components/SignIn";

interface Props extends React.Props<any> {
    to: string
}
type AnimProps = {
  alerts: Array<any>,
  setUser: Function,
  setAlerts: Function,
  user: Object
}
function NavLink(props: Props) {
    return (
      <li style={styles.navItem}>
        <Link {...props} style={{ color: "inherit" }} />
      </li>
    );
  }

  // export default function AnimationApp(props) {
  const AnimationApp: React.FC<AnimProps> = props => {
      let location = useLocation();

    // const NavLink = () => (
    //         <li style={styles.navItem}>
    //             <Link {...props} style={{ color: "inherit" }} />
    //         </li>
    // )

    return (
      <div style={styles.fill}>
        <ul style={styles.nav}>
          {/*<NavLink to="/tecnical-resources">
            <div>
                <h1>Teknik Bilgiler</h1>
            </div>

          </NavLink>
          <NavLink to="/services">
             Services
          </NavLink>
          <NavLink to="/contact-us">
            Contact-Us
    </NavLink>*/}
        </ul>

        <div style={styles.content}>
          <TransitionGroup>
            {/*
              This is no different than other usage of
              <CSSTransition>, just make sure to pass
              `location` to `Switch` so it can match
              the old location as it animates out.
            */}
            <CSSTransition
              key={location.key}
              classNames="fade"
              timeout={300}
            >
              <Switch location={location}>
                <Route exact path="/" children={<div style={{position: "absolute"}}><MainPage /></div>} />
                <Route path="/technical-resources" children={<h1>Teknik Bilgiler</h1>} />
                <Route path="/services" children={<div style={{position: "absolute", width: "100vh"}}><Services/></div>} />
                <Route
                  path="/references"
                  render={() => (
                      <h1>İş Ortaklarımız</h1>
                  )}
                />
                <Route
                  path="/sign-up"
                  render={() => (
                    <SignUp
                      alerts={props.alerts}
                      setAlerts={props.setAlerts}
                      setUser={props.setUser}
                    />
                  )}
                />
                {!props.user ? (
                  <Route
                    path="/sign-in"
                    render={() => (
                      <SignIn
                        alerts={props.alerts}
                        setAlerts={props.setAlerts}
                        setUser={props.setUser}
                      />
                    )}
                  />
                ) : null}
                <Route path="/contact-us" children={<div style={{position: "absolute"}}><ContactUs /></div>} />
              </Switch>
            </CSSTransition>
          </TransitionGroup>
        </div>
      </div>
    );
}

interface Stylings {
    fill?: Object,
    content?: Object,
    nav?: Object,
    navItem?: Object,
    hsl?: Object,
    rgb?: Object
}

const styles: Stylings = {};

styles.fill = {
  position: "absolute",
  left: 0,
  right: 0,
  top: 100,
  bottom: 0
};

styles.content = {
  ...styles.fill,
  top: "40px",
  textAlign: "center",
  width: "1200px",
  left: "25%"
};

styles.nav = {
  padding: 0,
  margin: 0,
  position: "absolute",
  top: 0,
  height: "40px",
  width: "100%",
  display: "flex"
};

styles.navItem = {
  textAlign: "center",
  flex: 1,
  listStyleType: "none",
  padding: "10px"
};

styles.hsl = {
  ...styles.fill,
  color: "white",
  paddingTop: "20px",
  fontSize: "30px"
};

styles.rgb = {
  ...styles.fill,
  color: "white",
  paddingTop: "20px",
  fontSize: "30px"
};
export default AnimationApp